(() => {
  // Function to calculate and update the --open-size for each details element
  function updateOpenSize() {
    const accordionWrapper = document.querySelector('.uom-2035-foundations');
    if (!accordionWrapper) return;

    const allDetails = accordionWrapper.querySelectorAll('details');
    if (allDetails.length === 0) return;

    // Check viewport width to determine layout
    const isHorizontal = window.innerWidth >= 1200;

    if (isHorizontal) {
      // Horizontal layout: animate width
      const totalAvailableSpace = accordionWrapper.offsetWidth;
      let totalSummarySpace = 0;
      let openDetailsCount = 0;

      allDetails.forEach((details) => {
        const summary = details.querySelector('summary');
        if (summary) {
          totalSummarySpace += summary.offsetWidth;
        }
        if (details.hasAttribute('open')) {
          openDetailsCount++;
        }
      });

      const remainingSpace = totalAvailableSpace - totalSummarySpace;
      const spacePerOpenDetails =
        openDetailsCount > 0 ? Math.max(0, remainingSpace / openDetailsCount) : 0;

      allDetails.forEach((details) => {
        details.style.setProperty('--open-size', `${spacePerOpenDetails}px`);
        // Remove height property in horizontal mode
        details.style.removeProperty('--open-height');
      });
    } else {
      // Vertical layout: animate height
      allDetails.forEach((details) => {
        // Look for a child with class 'details-content-wrapper'
        const content = details.querySelector('.details-content-wrapper');
        if (details.hasAttribute('open') && content) {
          // Temporarily set height to 'auto' to measure full content
          content.style.height = 'auto';
          const height = content.scrollHeight + 'px';
          details.style.setProperty('--open-height', height);
          // Reset inline height so CSS variable takes over
          content.style.height = '';
        } else {
          details.style.setProperty('--open-height', '0px');
        }
        // Remove width property in vertical mode
        details.style.removeProperty('--open-size');
      });
    }
  }

  // Create a ResizeObserver to watch for size changes
  const resizeObserver = new ResizeObserver((entries) => {
    updateOpenSize();
  });

  // Create a MutationObserver to watch for open/close state changes
  const mutationObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        shouldUpdate = true;
      }
    });

    if (shouldUpdate) {
      // Small delay to ensure DOM has updated
      setTimeout(updateOpenSize, 10);
    }
  });

  // Window resize listener
  function handleWindowResize() {
    updateOpenSize();
  }

  // Initialize observers when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const accordionWrapper = document.querySelector('.uom-2035-foundations');
    if (!accordionWrapper) return;

    // Start observing the accordion wrapper for size changes
    resizeObserver.observe(accordionWrapper);

    // Start observing all details elements for open/close state changes
    const allDetails = accordionWrapper.querySelectorAll('details');
    allDetails.forEach((details) => {
      mutationObserver.observe(details, {
        attributes: true,
        attributeFilter: ['open'],
      });
    });

    // Listen for window resize to handle breakpoint changes
    window.addEventListener('resize', handleWindowResize);

    // Set initial values
    updateOpenSize();
  });
})();
